// extracted by mini-css-extract-plugin
export var activeDot = "_32-c";
export var buttonContainer = "_32-9";
export var channelButton = "_32-a";
export var clickable = "_32-d";
export var content = "_32-0";
export var contentFull = "_32-2";
export var contentThird = "_32-1";
export var contentWrapper = "_32-7";
export var description = "_32-5";
export var heightShort = "_32-f";
export var image = "_32-3";
export var imageContainer = "_32-4";
export var selectButton = "_32-e";
export var spinnerContainer = "_32-b";
export var titleContent = "_32-8";
export var titleWrapper = "_32-6";